import Config from 'Config/Environment';

const { environment } = Config;
const language = localStorage.getItem('language');
export const SPANISH = 'sp';
export const ENGLISH = 'en';

export const DATE = language === `"${SPANISH}"` ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
export const LOCALES = language === `"${SPANISH}"` ? 'es-MX' : 'en-US';

export const EVENTS = {
  ON_CHANGE: 'onChange',
  OM_KEY_PRESS: 'onKeyPress',
};

export const KEYS = {
  ENTER: 'Enter',
};

export const MODULE = 'module';
export const VIDEO = 'video';
export const AUDIO = 'audio';
export const MEET = 'meet';
export const DOCUMENT = 'document';
export const FACE_TO_FACE = 'faceToFace';
export const MANUAL_EVALUATION = 'manualEvaluation';
export const AUTOMATIC_EVALUATION = 'automaticEvaluation';

export const LESSON_TYPES = {
  VIDEO: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c00',
  AUDIO: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c01',
  DOCUMENT: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c02',
  MEET: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c03',
  FACE_TO_FACE: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c04',
  MANUAL_EVALUATION: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c05',
  AUTOMATIC_EVALUATION: 'ac1c59f8-77d3-4daa-be01-8d9a10ba6c06',
};

export const GOOGLE_MAPS_URL = 'https://google.com/maps/search';

export const ONLINE = 'online';
export const IN_PERSON = 'inPerson';

export const FILE_EXTENSIONS = {
  PDF: 'pdf',
  DOC: 'doc',
  DOCX: 'docx',
};

export const CUSTOM_BORDER_URL =
  "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='limegreen' stroke-width='4' stroke-dasharray='15' stroke-dashoffset='30' stroke-linecap='round'/%3e%3c/svg%3e";

export const MULTIPLE_CHOICE = 'multipleChoice';
export const MULTIPLE_CHOICE_ID = '5988b765-9af2-45b2-b92b-92b78ac0a891';
export const FREE_RESPONSE = 'freeResponse';
export const FREE_RESPONSE_ID = '5988b765-9af2-45b2-b92b-92b78ac0a892';
export const EMPLOYEE_ROLE_ID = '3923b9fe-047a-4abf-b2e4-46a18ca47c3b';

// AWS S3 course folders
export const S3_LESSONS = 'courses/modules';
export const S3_DOCUMENTS = 'courses/documents';
export const S3_IMAGES = 'courses/images';
// S3_EVIDENCES is used to store the evidences of the user evaluations
export const S3_EVIDENCES = 'evidences';

/** ID de los estatus de un curso */
export const COURSE_STATUS_APPROVED = '93c7e7ea-befb-4abf-b90a-f8ca22e15710';
export const COURSE_STATUS_PENDING = '93c7e7ea-befb-4abf-b90a-f8ca22e15711';
export const COURSE_STATUS_REJECTED = '93c7e7ea-befb-4abf-b90a-f8ca22e15712';

/** Nombre de los estatus de un curso  */
export const COURSE_STATUS_APPROVED_NAME = 'Aprobado';
export const COURSE_STATUS_PENDING_NAME = 'Por Cursar';
export const COURSE_STATUS_REJECTED_NAME = 'Reprobado';

/** ID de los roles de un usuario */
export const ROLE_ADMINISTRATOR = '3923b9fe-047a-4abf-b2e4-46a18ca47c3a';

export const TERMINAL_BASE = '00f103fb-b5ed-40c0-b3b5-b8bba962505f';
export default {
  DATE,
  LOCALES,
  SPANISH,
  ENGLISH,
  EVENTS,
  KEYS,
  GOOGLE_MAPS_URL,
  ONLINE,
  IN_PERSON,
  MANUAL_EVALUATION,
  AUTOMATIC_EVALUATION,
  FILE_EXTENSIONS,
  CUSTOM_BORDER_URL,
  MULTIPLE_CHOICE,
  MULTIPLE_CHOICE_ID,
  FREE_RESPONSE,
  FREE_RESPONSE_ID,
  EMPLOYEE_ROLE_ID,
  S3_LESSONS,
  S3_DOCUMENTS,
  S3_IMAGES,
  S3_EVIDENCES,
  COURSE_STATUS_APPROVED,
  COURSE_STATUS_PENDING,
  COURSE_STATUS_REJECTED,
  COURSE_STATUS_APPROVED_NAME,
  COURSE_STATUS_PENDING_NAME,
  COURSE_STATUS_REJECTED_NAME,
  ROLE_ADMINISTRATOR,
};
